import React, { useContext, useEffect, useState } from "react";
import TypewriterComponent from "typewriter-effect";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { setJobFunction } from "../../apis/ext";
import { useMutation, useQueryClient } from "react-query";
import SharedDataContext from "../../SharedDataContext";
import Input from "../Tags/Input";
import { jobFunctions } from "../../constant";

export default function Onboarding() {
  const queryClient = useQueryClient();
  const { userData } = useContext(SharedDataContext);
  const [onboarded, setOnboarded] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [formHasError, setFormHasError] = useState(false);
  const [currentJobFunction, setCurrentJobFunction] = useState("");
  const [currentJobTitle, setCurrentJobTitle] = useState("");

  const setJobFunctionFn = useMutation("set_jobfunction", setJobFunction, {
    onSuccess(data, variables, context) {
      console.log("success");
      setOnboarded(true);
      setTimeout(() => {
        queryClient.invalidateQueries("get_user");
      }, 2000);
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleSetJobFunction = () => {
    if (currentJobFunction === "") {
      setFormHasError(true);
      return;
    }
    if (currentJobTitle === "") {
      setFormHasError(true);
      return;
    }
    if (setJobFunctionFn.isLoading) {
      return;
    }
    let payload = {
      job_function: currentJobFunction,
      job_title: currentJobTitle,
    };
    console.log("payload", payload);
    setJobFunctionFn.mutate({
      data: payload,
    });
  };

  useEffect(() => {
    return () => {
      setShowForm(false);
    };
  }, []);
  return (
    <>
      {onboarded ? (
        <div className="py-1 h-[80vh] flex items-center justify-center">
          <div className="text-center space-y-2">
            <h1 className="text-[18px]">Perfect! 🎉</h1>
            <h2 className="text-[18px]">We're all set :)</h2>
          </div>
        </div>
      ) : (
        <div className="py-1">
          <h3 className=" py-2 ">
            <TypewriterComponent
              onInit={(typewriter) => {
                typewriter
                  .typeString(`<span class="font-bold">Hi ${userData?.name},</span>`)
                  .pauseFor(300)
                  .typeString(
                    `<span class="font-bold inline-flex items-start pl-1"> I'm ${process.env.REACT_APP_APP_NAME} AI  <Image className="no-invert" src="/images/ext/ai.svg" alt="AI" class="mx-1 inline" /></span>`
                  )
                  .pauseFor(600)
                  .typeString(
                    `<span class="block mt-3"> I'm a helpful assistant designed to make your processes more efficient. Nice to meet you!</span>`
                  )
                  .pauseFor(600)
                  .typeString(
                    `<span class="block mt-5"> To better assist you with your needs, can you tell me your job function and job title?</span>`
                  )
                  .pauseFor(300)
                  .callFunction(() => {
                    setShowForm(true);
                  })
                  .start();
              }}
              options={{ delay: 15, cursor: "" }}
            />
          </h3>
          {showForm && (
            <div className="bg-background rounded-[8px] py-3 px-5 slide-in">
              <Label className="text-gray-500 mb-2 inline-block">
                Job Function <span className="text-red-400">*</span>
              </Label>
              <Select
                className="w-full"
                onValueChange={(value) => {
                  setCurrentJobFunction(value);
                  console.log("value", value);
                }}
              >
                <SelectTrigger className="w-full rounded-[8px]">
                  <SelectValue placeholder="Please Select Job Function" />
                </SelectTrigger>
                <SelectContent>
                  {jobFunctions.map((item) => (
                    <SelectItem value={item.value}>{item.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {currentJobFunction === "" && formHasError && (
                <p className="text-red-400  mt-2 text-[12px]">Please select a job function</p>
              )}
              <Label className="text-gray-500 inline-block mt-4 mb-2">
                Job Title <span className="text-red-400">*</span>
              </Label>
              <Input
                onChange={(e) => {
                  setCurrentJobTitle(e.target.value);
                }}
              />
              {currentJobTitle === "" && formHasError && (
                <p className="text-red-400 mt-2 text-[12px]">Please enter your job title</p>
              )}

              <div className="flex justify-end mt-1">
                <Button
                  variant="outline"
                  className="rounded-[8px] mt-3"
                  onClick={setJobFunctionFn.isLoading ? void 0 : handleSetJobFunction}
                >
                  {" "}
                  Send
                  {setJobFunctionFn.isLoading && <span className="loader_circle ml-2"></span>}
                </Button>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
}
